<template>
  <div>
    请在微信中打开
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  created() {
      console.log('tag0')
    this.getHospitalConfig().then(res => {
      this.setWxConfig(res);
    });
  },
  methods: {
    ...mapActions("home", ["getHospitalConfig"]),
    setWxConfig(res) {
      console.log('tag1',res)
      const that = this;
      this.$wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.appId, // 必填，公众号的唯一标识
        timestamp: res.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.nonceStr, // 必填，生成签名的随机串
        signature: res.signature, // 必填，签名
        jsApiList: ["scanQRCode"] // 必填，需要使用的JS接口列表
      });
      this.$wx.ready(function() {
      console.log('tag2')
        that.startScan();
      });
      this.$wx.error(function(error) {
      console.log('tag3',error)
        that.$router.go(-1);
        that.$toast(error.message);
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      });
    },
    startScan() {
      this.$router.go(-1);
      this.$wx.scanQRCode({
        needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function() {}
      });
    }
  }
};
</script>
